import { Accordion } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { createFaviconUrl } from '~/views/alfred/research/utils/createFaviconUrl';

import styles from './CitationsSection.module.scss';
import * as S from './CitationsSection.styles';

export interface CitationsSectionProps {
  title: string;
  count: number;
  items: { title: string; url: string }[];
  isExpanded?: boolean;
}

export const CitationsSection = ({
  title,
  count,
  items,
  isExpanded = false,
}: CitationsSectionProps) => {
  const { t } = useTranslation(['earnings']);

  const handleItemClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const accordionItems = [
    {
      title: (
        <S.TitleContainer>
          <S.TitleLabel>{title}</S.TitleLabel>
          <S.CountLabel>
            {t('earnings:earningsInsight.drawer.count', { count })}
          </S.CountLabel>
        </S.TitleContainer>
      ),
      content: (
        <S.ItemsWrapper>
          {items.map((item, index) => {
            const favicon = createFaviconUrl(item.url);

            return (
              <S.ItemContainer
                key={index}
                onClick={() => handleItemClick(item.url)}
              >
                {favicon && <S.StyledFavicon src={favicon} />}
                <S.ItemContent>
                  <S.CitationTitle>{item.title}</S.CitationTitle>
                  <S.CitationUrl>{item.url}</S.CitationUrl>
                </S.ItemContent>
              </S.ItemContainer>
            );
          })}
        </S.ItemsWrapper>
      ),
      expandedByDefault: isExpanded,
    },
  ];
  return (
    <Accordion className={styles.styledAccordion} items={accordionItems} />
  );
};
